import { getObjectStringPropValue } from './utils/ObjectUtils';
import { isStringWithValue } from './utils/ValidationUtils';
const addError = (condition, error, errors) => {
    if (condition) {
        errors.push(error);
    }
};
export const hasVistaChatPropValidationError = (ivaChatProps, logger) => {
    const errors = [];
    let platformInformationErrors = [];
    if (ivaChatProps.userMetadata) {
        addError(!isStringWithValue(getObjectStringPropValue(ivaChatProps.userMetadata, 'currentEnterpriseId')), 'userMetadata.currentEnterpriseId', errors);
        if (Array.isArray(ivaChatProps.userMetadata.platformInformation)
            && ivaChatProps.userMetadata.platformInformation.length >= 1) {
            ivaChatProps.userMetadata.platformInformation.forEach((platformInfo, index) => {
                addError(!isStringWithValue(getObjectStringPropValue(platformInfo, 'enterpriseId')), 'enterpriseId', platformInformationErrors);
                addError(!isStringWithValue(getObjectStringPropValue(platformInfo, 'accountNumber')), 'accountNumber', platformInformationErrors);
                addError(!isStringWithValue(getObjectStringPropValue(platformInfo, 'cardName')), 'cardName', platformInformationErrors);
                addError(!isStringWithValue(getObjectStringPropValue(platformInfo, 'clientId')), 'clientId', platformInformationErrors);
                addError(!isStringWithValue(getObjectStringPropValue(platformInfo, 'imageURL')), 'imageURL', platformInformationErrors);
                if (platformInformationErrors.length >= 1) {
                    errors.push(`Platform info item ${index} has invalid data on props: (${platformInformationErrors.join(', ')})`);
                    platformInformationErrors = [];
                }
            });
        }
        else {
            errors.push("userMetadata.platformInformation");
        }
    }
    else {
        errors.push("userMetadata");
    }
    return errors.length >= 1;
};
